import OSS from 'ali-oss'
// import md5 from "js-md5"
export default {
  createOssClient () {
    return new Promise((resolve, reject) => {
      const client = new OSS({
        region: 'oss-cn-shanghai', // 请设置成你的
        accessKeyId: 'LTAI5tAtAWus5pwewE4aF9EQ', // 请设置成你的
        accessKeySecret: 'fomMQcXxtXQArUALON9urvxSvvDuhg', // 请设置成你的
        bucket: 'exerlalnd', // 请设置成你的
        secure: true // 上传链接返回支持https
      })
      resolve(client)
    })
  },
  ossUploadFile (option, upvideodata) {
    const file = option.files[0]
    const self = this
    return new Promise((resolve, reject) => {
      const date = new Date().getTime() // 当前时间戳
      // 这里匹配到的是
      const extensionName = file.name.split('.')[file.name.split('.').length - 1] // 文件扩展名
      const fileName = 'video_bbs/video' + date + '.' + extensionName // 文件名字（相对于根目录的路径 + 文件名）
      // 执行上传
      self.createOssClient().then(client => {
        // 异步上传,返回数据
        resolve({
          fileName: file.name,
          fileUrl: fileName
        })
        // 上传处理
        // 分片上传文件
        client.multipartUpload(fileName, file, {
          progress: function (p) {
            const e = {}
            e.percent = Math.floor(p * 100)
            // option.onProgress = e.percent
            upvideodata.onProgress = e.percent
          },
          parallel: 4,
          partSize: 1024 * 1024 * 2
        }).then(val => {
          window.url = val
          if (val.res.statusCode === 200) {
            // option.onSuccess(val)
            this.video_url = val.res.requestUrls[0].split('?')[0] // 这个也很重要,必须切割,要不链接显示错误
            return val
          } else {
            // option.onError('上传失败')
          }
        },
        err => {
          // option.onError('上传失败')
          reject(err)
        }
        )
      })
    })
  }
}
